import React from 'react';
import { IProduct } from '../../../Types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '@material-ui/core/Card';
import Product from './Product';

const useStyles = makeStyles((theme: any) => ({
  product: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

export default function MobileProduct({ product }: { product: IProduct }) {
  const classes = useStyles();
  const { name, image } = product;

  return (
    <Card variant="outlined" className={classes.product}>
      <Product name={name} image={image} lineOnEditMode={false} />
    </Card>
  );
}
